/**
 * The identity of a "drop this stop on another day" target.
 *
 * Kept apart from the component that renders them so a day target can be
 * recognised (in TimelineRail's drag handler) without importing a component,
 * and so the module that draws them exports nothing but components.
 */

/** Namespaced so a drop on a day can never be mistaken for a drop on a card. */
export const DAY_DROP_PREFIX = 'day-drop:';

export const dayDropId = (dayId: string): string => `${DAY_DROP_PREFIX}${dayId}`;

export const dayIdFromDrop = (id: string): string | null =>
  id.startsWith(DAY_DROP_PREFIX) ? id.slice(DAY_DROP_PREFIX.length) : null;
